import { connect } from 'react-redux';
import { State } from 'store/types';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { AB_PAGE_NOT_FOUND } from 'constants/experiments';

const mapStateToProps = (state: State) => {
  const { appReducer } = state;
  return {
    statusCode: appReducer.statusCode,
    showPageNotFoundV2: getEligibleForVariant(state, AB_PAGE_NOT_FOUND, 'A'),
  };
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const getView = () => require(`./${__PLATFORM__}/View`).default;

export default connect(mapStateToProps)(getView());
